<div class="d-flex align-items-center parent">
    <div ngbDropdown placement="bottom-left" [ngClass]="!isOpen ? 'ngbDropdown-translate' : 'ngbDropdown'">
        <div [ngClass]="isOpen ? 'div-translate' : 'div-not-translate'">
            <form trapFocus autocomplete="off">
                <input #searchPersonaField class="search-input form-control"
                    [ngClass]="showEnvWarning ? 'white-input' : ''" type="text" name="quick-search" id="quick-search"
                    [placeholder]="'buttons.personaSearch' | translate" [(ngModel)]="searchValue"
                    (ngModelChange)="isLoading=true; result=[]; this.quickSearch.next({ value: $event })">
            </form>
            <div *ngIf="isOpen && isLoading && searchValue.length > 0" class="ng-spinner-loader"
                [ngClass]="showEnvWarning ? 'white-loader' : ''"></div>
            <div ngbDropdownMenu aria-labelledby="quick-search" [ngClass]="searchValue.length > 0 ? 'show' : ''"
                class="scrollable-menu" role="menu" placement="bottom-left"
                style="position: absolute; min-width: 100%; width: max-content;">
                <div ngbDropdownItem *ngFor="let res of result">
                    <div *ngIf="!res.manager_name && !res.manager_identifier else managerLink" class="row menu-button" (click)="redirectToUser(res.id)">
                        <span  [innerHTML]="res.id + ' - ' + res.name | highlight: searchValue"></span>
                    </div>
                    <ng-template #managerLink>
                        <div class="row menu-button" (click)="redirectToUser(res.id)">
                            <span  [innerHTML]="res.manager_name | highlight: searchValue"></span>
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="result.length === 0 && searchValue.length > 0 && !isLoading" ngbDropdownItem>
                    <div class="row menu-button">
                        {{'buttons.noResults' | translate}}
                    </div>
                </div>
            </div>
            <button class="btn buttons-search" (click)="closeSearch()">
                <div>
                    <img [src]="searchValue.length > 0 ? 'assets/ico/clear-button.svg' : 'assets/ico/search.svg'"
                        [ngClass]="showEnvWarning ? 'fill-white' : ''"
                        [ngClass]="searchValue.length > 0 ? 'clear-search-icon' : 'search-icon-person'" alt="clear">
                </div>
            </button>
        </div>
    </div>
    <div class="blocker"></div>
</div>